import { useAtom } from 'jotai';
import { useResetAtom } from 'jotai/utils';

import { stateFiltersAtom } from '../store/atoms/stateFiltersAtom';
import type { StateFilters } from '../types/stateFilters';

/**
 * Hook para gerenciar os filtros (client-side) da listagem de Estados.
 *
 * @returns Filtros atuais e funções para atualizar e resetar.
 */
export function useStateFilters() {
  const [filters, setFilters] = useAtom(stateFiltersAtom);
  const resetFilters = useResetAtom(stateFiltersAtom);

  /**
   * Atualiza parcialmente os filtros. Reseta para a primeira página, exceto
   * quando o próprio `page` é fornecido no `partial` (navegação de páginas).
   */
  const updateFilters = (partial: Partial<StateFilters>) => {
    setFilters(prev => {
      const resetPage = 'page' in partial ? {} : { page: 1 };
      return { ...prev, ...resetPage, ...partial };
    });
  };

  return { filters, updateFilters, resetFilters } as const;
}
